module.exports = __webpack_public_path__ + "assets/img/Rosemary-Health-3-Social-Static-Ad-w960.216d3350.png";